/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./chartCustomOptionsEditor.vue?vue&type=template&id=ddbb60e2"
import script from "./chartCustomOptionsEditor.vue?vue&type=script&lang=js"
export * from "./chartCustomOptionsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports